import React from 'react';
import CategorySelect from 'pages/content_library/content_assessment/edit_settings/components/CategoriesSelect';
import { changeAssessmentCategory } from 'requests/AssessmentRequests';
import { checkHasCompanyFeature } from 'helper/commonFunctions';
import EditPanelSection from '../EditPanelSection';
import SettingsFieldChange from '../SettingsFieldChange';
import SlugSettings from '../SlugSettings';
import BrandingDetails from '../BrandingDetails';

const DetailSettings = ({ ...props }) => {
    const { company, audition, loadEditScript, setSaving } = props;

    const companyHasCMS = checkHasCompanyFeature(company, 'CMS');
    const onChangeCategory = async ({ category }) => {
        setSaving(true);
        await changeAssessmentCategory(audition.slug, category);
        loadEditScript();
        setSaving(false);
    };

    return (
        (
            <EditPanelSection>
                <SettingsFieldChange
                    maxLength={100}
                    label="Assessment Name"
                    field="name"
                    className="u-mrg--bx3 u-mrg--tx0"
                    {...props}
                />
                <SettingsFieldChange
                    maxLength={1000}
                    hasCounter
                    field="description"
                    label="Assessment Description"
                    multiline
                    hintLabel="This Assessment description is not visible to your candidates"
                    {...props}
                />
                {
                    companyHasCMS && (
                        <CategorySelect {...props} changeAssessmentSettings={onChangeCategory} />
                    )
                }
                <SlugSettings {...props} />
                <BrandingDetails {...props} />
            </EditPanelSection>
        )
    );
};

export default DetailSettings;
